import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGames } from '@/Context/GameContext';
import styles from './Sportsbook.module.css';

/**
 * Sportsbook Component
 * Displays sports categories in a horizontal slider/carousel
 */

const sportsData = [
  {
    id: 1,
    name: 'Tennis',
    image: '/assets/images/sports/tennis.webp',
    link: '/sports?tab=tennis',
  },
  {
    id: 2,
    name: 'Basketball',
    image: '/assets/images/sports/basketball.webp',
    link: '/sports?tab=basketball',
  },
    {
    id: 5,
    name: 'American Football',
    image: '/assets/images/sports/american-football.png',
    link: '/sports?tab=american-football',
  },
  // {
  //   id: 21,
  //   name: 'Cricket',
  //   image: '/assets/images/sports/cricket.webp',
  //   link: '/sports?tab=cricket',
  // },
  {
    id: 3,
    name: 'E-Sports',
    image: '/assets/images/sports/eports.webp',
    link: '/sports?tab=esports',
    isEsports: true, // Flag to identify e-sports for special handling
  },
  {
    id: 4,
    name: 'Football',
    image: '/assets/images/sports/football.webp',
    link: '/sports?tab=football',
  },
  {
    id: 21,
    name: 'Cricket',
    image: '/assets/images/sports/cricket.webp',
    link: '/sports?tab=cricket',
  },
  // {
  //   id: 6,
  //   name: 'Racing',
  //   image: '/assets/images/sports/racing.png',
  //   link: '/sports?tab=racing',
  // },
];

const Sportsbook = () => {
  const navigate = useNavigate();
  const scrollContainerRef = useRef(null);
  const { handleJsGameLaunch } = useGames();

  // E-sports game ID (TFGaming)
  const ESPORTS_GAME_ID = '4ee8e0051a035b463b47c3c473ce317d';

  const handleCardClick = async (sport) => {
    // If it's E-Sports, launch the game instead of navigating
    if (sport.isEsports) {
      await handleJsGameLaunch(ESPORTS_GAME_ID, navigate);
    } else {
      // For regular sports, navigate to sports page
      navigate(sport.link);
    }
  };


  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.title}>Sports</h2>
      </div>

      <div className={styles.sliderWrapper}>
        <div className={styles.scrollContainer} ref={scrollContainerRef}>
          <div className={styles.sliderContent}>
            {sportsData.map((sport) => (
              <div
                key={sport.id}
                className={styles.sportCard}
                onClick={() => handleCardClick(sport)}
              >
                <div className={styles.cardImageContainer}>
                  <img
                    src={sport.image}
                    alt={sport.name}
                    className={styles.cardImage}
                    onError={(e) => {
                      e.target.src = '/assets/images/placeholder.png';
                    }}
                  />
                  {/* <div className={styles.glowEffect}></div> */}
                </div>
             {/*}   <div className={styles.cardTitle}>{sport.name}</div>*/}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sportsbook;
